import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';

import HorizontalForm from 'components/form/horizontal_form';

export default class LeaseSpaceForm extends React.Component {
  static propTypes = {
    description: PropTypes.string,
    handleChange: PropTypes.func.isRequired,
    handleLeaseSpaceChange: PropTypes.func.isRequired,
    leaseDetails: PropTypes.object,
    leaseRateUnitOptions: PropTypes.array.isRequired,
    leaseTypeOptions: PropTypes.array.isRequired,
    measurementAreaLabel: PropTypes.string.isRequired,
    stateOptions: PropTypes.arrayOf(PropTypes.array).isRequired
  }

  render() {
    return (
      <React.Fragment>
        <HorizontalForm.TextInput
          name='suite'
          required
          value={this.props.leaseDetails.suite}
          onChange={this.props.handleLeaseSpaceChange}
        />
        <HorizontalForm.Checkbox
          name='sublease'
          value={this.props.leaseDetails.sublease}
          onChange={this.props.handleLeaseSpaceChange}
        />
        <Row>
          <Col xs={6}>
            <HorizontalForm.TextInput
              name='leaseRate'
              number
              value={this.props.leaseDetails.leaseRate}
              onChange={this.props.handleLeaseSpaceChange}
            />
          </Col>
          <Col xs={4}>
            <HorizontalForm.Select
              name='leaseRateUnits'
              options={this.props.leaseRateUnitOptions}
              value={this.props.leaseDetails.leaseRateUnits}
              onChange={this.props.handleLeaseSpaceChange}
            />
          </Col>
        </Row>
        <HorizontalForm.TextInput
          name='additionalRent'
          number
          value={this.props.leaseDetails.additionalRent}
          onChange={this.props.handleLeaseSpaceChange}
        />
        <HorizontalForm.TextInput
          name='leaseTermMonths'
          number
          value={this.props.leaseDetails.leaseTermMonths}
          onChange={this.props.handleLeaseSpaceChange}
        />
        <HorizontalForm.Select
          includeBlank
          label='Lease Type'
          name='leaseTypeId'
          options={this.props.leaseTypeOptions}
          value={this.props.leaseDetails.leaseTypeId}
          onChange={this.props.handleLeaseSpaceChange}
        />
        <HorizontalForm.TextInput
          label='Escalation %'
          name='escalationPct'
          number
          value={this.props.leaseDetails.escalationPct}
          onChange={this.props.handleLeaseSpaceChange}
        />
        <HorizontalForm.TextInput
          label='NER($)'
          name='netEffectiveRate'
          number
          value={this.props.leaseDetails.netEffectiveRate}
          onChange={this.props.handleLeaseSpaceChange}
        />
        <HorizontalForm.TextInput
          label='Lease Note'
          name='leaseNote'
          value={this.props.leaseDetails.leaseNote}
          onChange={this.props.handleLeaseSpaceChange}
        />
        <HorizontalForm.TextInput
          label='Size (SF)'
          name='size'
          number
          value={this.props.leaseDetails.size}
          onChange={this.props.handleLeaseSpaceChange}
        />
        <HorizontalForm.TextInput
          label={`Min Divisible (${this.props.measurementAreaLabel})`}
          name='minDivisibleArea'
          number
          value={this.props.leaseDetails.minDivisibleArea}
          onChange={this.props.handleLeaseSpaceChange}
        />
        <HorizontalForm.TextInput
          label={`Max Contiguous (${this.props.measurementAreaLabel})`}
          name='maxContiguousArea'
          number
          value={this.props.leaseDetails.maxContiguousArea}
          onChange={this.props.handleLeaseSpaceChange}
        />
        <HorizontalForm.TextInput
          label='CAM'
          name='cam'
          number
          value={this.props.leaseDetails.cam}
          onChange={this.props.handleLeaseSpaceChange}
        />
        <HorizontalForm.TextInput
          label='CAM Description'
          name='camDescription'
          value={this.props.leaseDetails.camDescription}
          onChange={this.props.handleLeaseSpaceChange}
        />
        <HorizontalForm.TextArea
          label='Survey Description'
          name='description'
          value={this.props.description || ""}
          onChange={this.props.handleChange}
        />
      </React.Fragment>
    );
  }
}
